import { usersTextTicket } from "../services/userServices";
import { hiddenLoadingPage, showLoadingPage } from "./loadingPage";

export const ticketText = (id) => {
  return async (dispatch) => {
    try {
      dispatch(showLoadingPage());
      const { data } = await usersTextTicket(id);
      await dispatch({ type: "SET_TEXT_USER_TICKET", payload: data });
      dispatch(hiddenLoadingPage());
    } catch (ex) {
      console.log(ex);
      window.location.replace("/my-tickets");
    } finally {
    }
  };
};
export const clearTicketText = () => {
  return (dispatch) => {
    dispatch({ type: "CLEAR_TEXT_USER_TICKET", payload: {} });
  };
};
